module.exports = __webpack_public_path__ + "img/js-banner-1.be8a0156.png";